import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		grades: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/center/{centerId}/user/{username}/get-all-specialties')
				.then(({ data }) => {
					commit(types.STORE_GRADES, data);
					return data;
				});
		},

		reset({ commit }) {
			commit(types.RESET)
		}
	},

	mutations: {
		[types.STORE_GRADES](state, grades) {
			state.grades = grades;
		},

		[types.RESET](state) {
			state.grades = [];
		}
	},

	getters: {
		getGradeById: state => id => state.grades.find(c => c.SpecialtyId === id)
	}
}